(function() {
  function alignLinesWithImages() {
    const items = document.querySelectorAll('.mt-svg-numbered__item');
    
    items.forEach((item) => {
      const iconWrapper = /** @type {HTMLElement} */ (item.querySelector('.mt-svg-numbered__icon-wrapper'));
      const content = item.querySelector('.mt-svg-numbered__content');
      const imageWrapper = item.querySelector('.mt-svg-numbered__image-wrapper');
      
      if (!iconWrapper || !content) return;
      
      // 如果有图片，使用图片底部作为对齐点；否则使用内容区域底部
      const targetElement = imageWrapper || content;
      
      // 获取各个元素的位置信息
      const itemRect = item.getBoundingClientRect();
      const iconWrapperRect = iconWrapper.getBoundingClientRect();
      const targetRect = targetElement.getBoundingClientRect();
      
      // 计算目标元素的底部位置（相对于 icon-wrapper 顶部）
      const targetBottom = targetRect.bottom - iconWrapperRect.top;
      
      // 获取图标元素的实际位置和高度
      const iconElement = iconWrapper.querySelector('.mt-svg-numbered__icon');
      if (!iconElement) return;
      
      const iconRect = iconElement.getBoundingClientRect();
      
      // 计算图标底部相对于 icon-wrapper 顶部的位置
      const iconBottom = iconRect.bottom - iconWrapperRect.top;
      
      // 检查是否有connector（非最后一个项目）
      const connector = iconWrapper.querySelector('.mt-svg-numbered__connector');
      
      // 如果有connector（非最后一个项目），不显示::after，避免与connector重叠
      // connector已经负责了连接功能
      if (connector) {
        iconWrapper.style.removeProperty('--line-top');
        iconWrapper.style.removeProperty('--line-height');
        return;
      }
      
      // 只有最后一个项目（没有connector）才需要显示::after
      // 计算图标底部相对于 icon-wrapper 顶部的位置
      const lineStart = iconBottom;
      
      // 检测是否是移动端（断点与CSS保持一致：749px）
      const isMobile = window.innerWidth <= 749;
      
      // 计算直线应该的长度（从图标底部到目标元素底部）
      // 桌面端减去图片的padding 30px，移动端不减
      const paddingOffset = isMobile ? 0 : 30;
      const lineLength = targetBottom - lineStart - paddingOffset;
      
      // 设置直线的起始位置和高度，确保没有缝隙
      if (lineLength > 0) {
        iconWrapper.style.setProperty('--line-top', `${lineStart}px`);
        iconWrapper.style.setProperty('--line-height', `${lineLength}px`);
      } else {
        iconWrapper.style.removeProperty('--line-top');
        iconWrapper.style.removeProperty('--line-height');
      }
    });
  }
  
  // 初始化
  function init() {
    alignLinesWithImages();
    
    // 图片加载后重新计算
    const images = document.querySelectorAll('.mt-svg-numbered__image');
    images.forEach((img) => {
      const imageElement = /** @type {HTMLImageElement} */ (img);
      if (imageElement.complete) {
        alignLinesWithImages();
      } else {
        imageElement.addEventListener('load', alignLinesWithImages, { once: true });
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // 窗口大小改变时重新计算
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(alignLinesWithImages, 100);
  });
})();

